module.exports = __webpack_public_path__ + "static/img/minicons1.23efe1a0.png";